import { Grid4, Notification } from "iconsax-react";

export default function DashboardHeader() {
  return (
    <header className="h-14 flex items-center justify-between pr-[14px]">
      <button className="cursor-pointer">
        <Grid4 variant="Linear" size={20} color="white" />
      </button>

      <div className="flex items-center gap-5">
        <input
          placeholder="Search user, group..."
          className="py-1.5 px-2.5 rounded-[5px] bg-dark-10 h-8 w-[261px] text-sm text-dark-text placeholder:text-dark-70"
        />
        <button>
          <Notification variant="Bold" color="#FEFEFE" size={20} />
        </button>
      </div>
    </header>
  );
}
